import DoneRoundedIcon from '@mui/icons-material/DoneRounded';
import { Grow } from '@mui/material';
import { Grid } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  avatar: {
    backgroundColor: '#52daae',
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
  email: {
    color: theme.palette.text.secondary,
  },
}));

type SellerOptionProps = {
  name?: string;
  surname?: string;
  email?: string;
  profileUrl?: string;
  selected: boolean;
  hideEmail?: boolean;
};

const SellerOption = ({
  name,
  surname,
  email,
  profileUrl,
  selected,
  hideEmail,
}: SellerOptionProps) => {
  const { classes } = useStyles();

  return (
    <Grid
      container
      spacing={1}
      wrap="nowrap"
      sx={{
        alignItems: 'center',
      }}
    >
      <Grid>
        <Avatar alt="email" src={profileUrl} className={classes.avatar}>
          {(email && email[0].toUpperCase()) || (name && name[0].toUpperCase())}
        </Avatar>
      </Grid>
      <Grid size="grow">
        <Grid container>
          <Grid size={12}>
            {name && surname && <Typography color="textPrimary">{`${name} ${surname}`}</Typography>}
            {name && !surname && <Typography color="textPrimary">{name}</Typography>}
            {!name && !surname && <Typography color="textPrimary">-</Typography>}
          </Grid>
          {!hideEmail && (
            <Grid size={12}>
              <Typography color="textSecondary" variant="body2">
                {email || '-'}
              </Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid>
        <Grow in={selected}>
          <DoneRoundedIcon />
        </Grow>
      </Grid>
    </Grid>
  );
};

export default SellerOption;
